// frontend/shared-ui/src/forms/schemas/device.js
export default {
    slug: 'device',
    label: 'Active Devices (ONT / OLT / Media Converter)',
    defaultUnit: 'pcs',
    costDefaults: {
        avgVolumeCbm: 0.02,
        suggestedMarkupPct: 30,
        freightSensitivity: 'medium',
        note: 'ONT units ~0.5–1 CBM per 100; OLTs are 2–3 CBM each',
    },
    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 2,
            fields: [
                {
                    key: 'deviceType', label: 'Device Type', type: 'select', required: true,
                    options: ['ONT', 'ONU', 'OLT', 'Media Converter', 'Router', 'Switch', 'Other']
                },
                {
                    key: 'ponType', label: 'PON Type', type: 'select',
                    options: ['GPON', 'EPON', 'XGS-PON', 'XG-PON', 'Combo']
                },
            ],
        },
        {
            id: 'optical',
            label: 'Optical',
            columns: 2,
            fields: [
                { key: 'wavelengthDown', label: 'Downstream Wavelength', type: 'number', unit: 'nm' },
                { key: 'wavelengthUp', label: 'Upstream Wavelength', type: 'number', unit: 'nm' },
                { key: 'downSpeed', label: 'Downstream Speed', type: 'text', placeholder: '2.5 Gbps' },
                { key: 'upSpeed', label: 'Upstream Speed', type: 'text', placeholder: '1.25 Gbps' },
            ],
        },
        {
            id: 'interfaces',
            label: 'Interfaces',
            columns: 3,
            fields: [
                { key: 'ethernetPorts', label: 'Ethernet Ports', type: 'number', min: 0 },
                { key: 'ponPorts', label: 'PON Ports', type: 'number', min: 0 },
                { key: 'uplinkPorts', label: 'Uplink Ports', type: 'text', placeholder: '4 x 10GE SFP+' },
                { key: 'usbPorts', label: 'USB Ports', type: 'number', min: 0 },
                { key: 'voipPorts', label: 'VoIP / POTS Ports', type: 'number', min: 0 },
                {
                    key: 'wifiStandard', label: 'Wi-Fi', type: 'select',
                    options: ['None', 'Wi-Fi 4', 'Wi-Fi 5', 'Wi-Fi 6', 'Wi-Fi 6E', 'Wi-Fi 7']
                },
            ],
        },
        {
            id: 'physical',
            label: 'Physical & Power',
            columns: 3,
            fields: [
                { key: 'powerConsumption', label: 'Power Consumption', type: 'number', unit: 'W' },
                { key: 'powerInput', label: 'Power Input', type: 'text', placeholder: 'DC 12V / AC 220V' },
                { key: 'rackUnits', label: 'Rack Units', type: 'select', options: ['1U', '2U', '3U', '4U', 'Desktop'] },
                { key: 'management', label: 'Management', type: 'text', placeholder: 'CLI, SNMP, Web, NMS' },
                { key: 'operatingTemp', label: 'Operating Temp', type: 'text', placeholder: '0 to 45 °C' },
            ],
        },
    ],

    buildSku(v) {
        const parts = [
            v.deviceType || '',
            v.ponType || '',
            v.wifiStandard && v.wifiStandard !== 'None' ? v.wifiStandard.replace(/\s+/g, '') : '',
            v.ethernetPorts ? `${v.ethernetPorts}GE` : '',
        ];
        return parts.filter(Boolean).join('-').toUpperCase().replace(/\s+/g, '');
    },

    buildName(v) {
        const bits = [];
        if (v.ponType) bits.push(v.ponType);
        if (v.deviceType) bits.push(v.deviceType);
        if (v.wifiStandard && v.wifiStandard !== 'None') bits.push(v.wifiStandard);
        if (v.ethernetPorts) bits.push(`${v.ethernetPorts}GE`);
        if (v.voipPorts) bits.push(`${v.voipPorts}POTS`);
        return bits.join(' ').trim() || 'Network Device';
    },

    attributeSchema: [
        { key: 'deviceType', label: 'Device Type' },
        { key: 'ponType', label: 'PON Type' },
        { key: 'wavelengthDown', label: 'Downstream Wavelength', unit: 'nm' },
        { key: 'wavelengthUp', label: 'Upstream Wavelength', unit: 'nm' },
        { key: 'downSpeed', label: 'Downstream Speed' },
        { key: 'upSpeed', label: 'Upstream Speed' },
        { key: 'ethernetPorts', label: 'Ethernet Ports' },
        { key: 'ponPorts', label: 'PON Ports' },
        { key: 'uplinkPorts', label: 'Uplink Ports' },
        { key: 'usbPorts', label: 'USB Ports' },
        { key: 'voipPorts', label: 'VoIP Ports' },
        { key: 'wifiStandard', label: 'Wi-Fi' },
        { key: 'powerConsumption', label: 'Power Consumption', unit: 'W' },
        { key: 'powerInput', label: 'Power Input' },
        { key: 'rackUnits', label: 'Rack Units' },
        { key: 'management', label: 'Management' },
        { key: 'operatingTemp', label: 'Operating Temp' },
    ],
};